import React from 'react';
import Header from  '../mini-components/Header';
import Form from  '../mini-components/Form';
import Footer from  '../mini-components/Footer';
import { NavLink } from 'react-router-dom';

const Home = () => {
    return (
        <div>
            <Header
               linkOne={<li><NavLink to="/signup">Register</NavLink></li> }
               linkTwo={<li><NavLink to="/signin">Login</NavLink></li> }
               linkThree={<li><NavLink to="/codeverify">Verification</NavLink></li> }
            />
            <Form />
            <Footer/>
        </div>
    )
}

export default Home
